import React from 'react';
import { Header, Footer } from '../components';

const DefaultLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main className="vh-100-custom">{children}</main>
      <Footer />
    </>
  );
};

export default DefaultLayout;
